var categoryProductsList = document.getElementById('category-products-list');

if (categoryProductsList) {
    var categoryProducts = categoryProductsList.getElementsByClassName('category-product');

    for (var i = 0; i < categoryProducts.length; i++) {
        var productVariantButtons = categoryProducts[i].getElementsByClassName('product-variant-btn');

        if (productVariantButtons.length === 2) {
            (function(){
                var variantSmButton = productVariantButtons[0];
                var variantButton = productVariantButtons[1];

                variantSmButton.addEventListener('click', function() {
                    changeVariantButtonsState(variantSmButton, variantButton);
                });

                variantButton.addEventListener('click', function() {
                    changeVariantButtonsState(variantButton, variantSmButton);
                });
            })();
        }
    }
}

function changeVariantButtonsState(clickedButton, unclickedButton) {
    if (clickedButton.classList.contains('collapsed')) {
        unclickedButton.classList.add('collapsed');
    } else {
        unclickedButton.classList.remove('collapsed');
    }
}
